import React from 'react'
import mdaq_logo from '../../assets/logo-short.svg'
import mdaq_4xpro_full_logo from '../../assets/4xpro-full-logo.svg'
import { Layout, Menu } from 'antd'
import { MoreOutlined } from '@ant-design/icons'
import { CollapseType } from 'antd/es/layout/Sider'
import { DARK } from '../../constant/theme'

const { Sider } = Layout

const GSider = (props: { theme: string; collapsed: boolean; onCollapsed: (collapsed: boolean, type: CollapseType) => void }) => {
    const { theme, collapsed, onCollapsed, ...rest } = props
    return (
        <Sider collapsible collapsed={collapsed} collapsedWidth='50' onCollapse={onCollapsed}>
            <div className='logoWrap'>
                {theme === DARK ? (
                    <img data-testid='main-logo-id' src={mdaq_4xpro_full_logo} className='mdaq-logo-style' alt='mdaq_dark_logo' />
                ) : (
                    <img data-testid='main-logo-id' src={mdaq_logo} className='mdaq-logo-style' alt='mdaq_logo' />
                )}
            </div>
            <Menu className='myfx-menu' theme='dark' mode='inline' {...rest} />
            <MoreOutlined className='trigger' data-testid='collapse-btn-id' onClick={() => onCollapsed(collapsed, 'clickTrigger')} />
        </Sider>
    )
}

export default GSider
